module.exports = __webpack_public_path__ + "img/propuneri.022d73b6.svg";